import $ from 'jquery';

const $processGraph = $( '.c-process-graph' );

if ( $processGraph.length ) {
	const $line = $( '.c-process-graph__stage-line', $processGraph );
	const lineLength = $line[ 0 ].getTotalLength();

	$line.css( {
		'stroke-dasharray': lineLength,
		'stroke-dashoffset': lineLength,
		opacity: 1,
	} );

	const speed = 40;

	let length = lineLength;
	let tickLength = lineLength;

	const tick = function() {
		if ( length === tickLength ) {
			requestAnimationFrame( tick );

			return;
		}

		if ( length > tickLength ) {
			tickLength += speed;

			if ( tickLength >= length ) {
				tickLength = length;
			}
		} else {
			tickLength -= speed;

			if ( tickLength <= length ) {
				tickLength = length;
			}
		}

		$line.css( 'stroke-dashoffset', tickLength );

		requestAnimationFrame( tick );
	};

	tick();

	const $headings = $( '.c-process-graph__headings li', $processGraph );
	const $contentsContainer = $( '.c-process-graph__contents' );
	const $contents = $( '.c-process-graph__content', $contentsContainer );

	$processGraph
		.on( 'mouseenter', '.c-process-graph__headings li', function() {
			const $li = $( this );
			const index = $li.index();
			const $content = $contents.eq( index );

			if ( ! $content.length || ! $content.hasClass( 'active' ) ) {
				$contents.filter( '.active' ).removeClass( 'active' );
			}

			$content.addClass( 'active' );

			const step = lineLength / ( $headings.length + 1 );
			let newLength = lineLength - ( ( index + 1 ) * step );

			if ( ( index + 1 ) === $headings.length ) {
				newLength = 0;
			}

			length = newLength;
		} )
		.on( 'mouseleave', '.c-process-graph__headings li', function() {
			length = lineLength;
			$contents.filter( '.active' ).removeClass( 'active' );
		} );

	const getElementHeight = function() {
		return $( this ).height();
	};

	const contentsResizeHandler = function() {
		const heights = $contents.map( getElementHeight ).toArray();
		const height = Math.max( ...heights );

		$contentsContainer.height( height );
		$contents.each( function( index ) {
			$( this ).css( 'top', Math.floor( ( height - heights[ index ] ) / 2 ) + 'px' );
		} );
	};

	contentsResizeHandler();

	$( window ).on( 'resize', contentsResizeHandler );
}
